export type RecordingStudioCountInBeats = 0 | 2 | 4 | 8

export const DEFAULT_COUNT_IN_BEATS: RecordingStudioCountInBeats = 0
export const DEFAULT_COUNT_IN_BPM = 120
export const MIN_COUNT_IN_BPM = 40
export const MAX_COUNT_IN_BPM = 240

export function normalizeCountInBeats(value: unknown): RecordingStudioCountInBeats {
  const numeric = Number(value)
  return numeric === 2 || numeric === 4 || numeric === 8 ? numeric : 0
}

export function normalizeCountInBpm(value: unknown): number {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return DEFAULT_COUNT_IN_BPM
  return Math.min(MAX_COUNT_IN_BPM, Math.max(MIN_COUNT_IN_BPM, Math.round(numeric)))
}

export function countInBeatIntervalMs(bpm: number): number {
  return 60_000 / normalizeCountInBpm(bpm)
}
